<template>
  <div class="publicItems">
    <el-card style="margin-bottom: 20px">
      <div class="selectionArea">
        <div class="item">
          <span class="item_title">公众号</span>
          <el-autocomplete
            v-model="parameterNames.app_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '公众号'"
            @clear="app_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放组</span>
          <el-autocomplete
            v-model="parameterNames.release_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放组'"
            @select="handleSelect"
            @clear="release_group_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">投手</span>
          <el-autocomplete
            v-model="parameterNames.pitcher_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投手'"
            @select="handleSelect"
            @clear="pitcher_id = null"
          />
        </div>
        <div class="item">
          <span class="item_title">运营组</span>
          <el-autocomplete
            v-model="parameterNames.operation_group_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营组'"
            @clear="operation_group_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">运营者</span>
          <el-autocomplete
            v-model="parameterNames.operation_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '运营者'"
            @clear="operation_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">平台</span>
          <el-autocomplete
            v-model="parameterNames.platform_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择平台"
            :clearable="true"
            @focus="current = '平台'"
            @clear="platform_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">书籍归属</span>
          <el-autocomplete
            v-model="parameterNames.book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请选择类型"
            :clearable="true"
            @focus="current = '书籍归属'"
            @clear="book_id = null"
            @select="handleSelect"
          />
        </div>
        <!-- <div class="item">
        <span class="item_title">书籍类型</span>
        <el-autocomplete
          v-model="parameterNames.belong_type_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择类型"
          :clearable="true"
          @focus="current = '书籍类型'"
          @clear="belong_type = null"
          @select="handleSelect"
        />
      </div> -->
        <div class="item">
          <span class="item_title">书籍类型</span>
          <el-select
            v-model="parameterNames.belong_type_name"
            clearable
            filterable
            placeholder="请选择类型"
          >
            <el-option
              v-for="(item, index) in optionbook"
              :key="index"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="item">
          <span class="item_title">书名</span>
          <el-autocomplete
            v-model="parameterNames.alias_book_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '书名'"
            @clear="alias_book_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">投放位置</span>
          <el-autocomplete
            v-model="parameterNames.position_id_name"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            :clearable="true"
            @focus="current = '投放位置'"
            @clear="position_id = null"
            @select="handleSelect"
          />
        </div>
        <div class="item">
          <span class="item_title">日期</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
        <div v-if="currentDisplayType === 'chart'" class="item">
          <span class="item_title">投放平台类型</span>
          <el-select v-model="parameterNames.launch_platform_type" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </div>
        <el-button
          style="height: 36px"
          type="primary"
          icon="el-icon-search"
          @click="search()"
        >搜索</el-button>
        <el-button
          style="height: 36px"
          type="default"
          icon="el-icon-refresh-left"
          @click="reset"
        >重置</el-button>
        <el-button
          v-if="currentDisplayType === 'list'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportExport"
        >导出报表</el-button>
        <el-button
          v-if="currentDisplayType === 'chart'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportExporting"
        >导出报表</el-button>
        <el-button
          v-if="currentDisplayType === 'list'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportExxiter"
        >导出</el-button>
        <el-button
          v-if="currentDisplayType === 'chart'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportExxiternew"
        >导出多维度</el-button>
        <el-button
          v-if="currentDisplayType === 'list'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportAdq"
        >广告主消耗导出</el-button>
        <el-button
          v-if="currentDisplayType === 'chart'"
          style="height: 36px"
          type="primary"
          icon="el-icon-bottom"
          @click="reportAdqnew"
        >广告主消耗导出</el-button>
        <!-- <el-button
          v-if="currentDisplayType == 'chart'"
          style="height: 36px"
          type="primary"
          size="mini"
          @click="$refs.files.click()"
        >上传表格<input
          ref="files"
          style="display:none;"
          type="file"
          multiple
          accept=".xlsx"
          @change="uploadPicturesr"
        ></el-button> -->
        <div class="style-tab">
          <div
            class="style-tubiao"
            :class="{ 'active-bg': currentDisplayType === 'chart' }"
            @click="switchToChart"
          >
            <div>新</div>
            <img
              style="height: 25px;width: 26px;"
              src="../../assets/images/13.小说/liebiao.png"
              alt=""
            >
          </div>
          <span>|</span>
          <div
            class="style-liebiao"
            :class="{ 'active-bg': currentDisplayType === 'list' }"
            @click="switchToList"
          >
            <img
              style="height: 25px;width: 26px;"
              src="../../assets/images/13.小说/tubiao.png"
              alt=""
            >
            <div>旧</div>
          </div>
        </div>
      </div>
    </el-card>
    <el-card v-if="currentDisplayType == 'list'">
      <!-- <div class="content1">
        <div>合计</div>
        <div class="content-right">
          <div>
            <div>新用户充值（扣除佣金）：</div>
            <div>
              {{
                tableData.total_data && tableData.total_data.new_user_recharge
                  ? tableData.total_data.new_user_recharge
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>消耗：</div>
            <div>
              {{
                tableData.total_data && tableData.total_data.total_consume
                  ? tableData.total_data.total_consume
                  : 0
              }}
            </div>
            <div
              v-if="total_data.contrast !== 0"
              :class="{
                color1: total_data.is_contrast,
                color2: !total_data.is_contrast
              }"
            >
              <div>{{ total_data.is_contrast ? '↑' : '↓' }}</div>
              <div>
                {{
                  total_data.is_contrast
                    ? total_data.contrast
                    : total_data.contrast * -1
                }}%
              </div>
            </div>
          </div>
          <div>
            <div>新用户roi：</div>
            <div>
              {{
                tableData.total_data && tableData.total_data.new_user_roi
                  ? tableData.total_data.new_user_roi
                  : 0
              }}
            </div>
            <div
              v-if="total_data.rio !== 0"
              :class="{ color1: total_data.is_rio, color2: !total_data.is_rio }"
            >
              <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>
              <div>
                {{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%
              </div>
            </div>
          </div>
          <div>
            <div>时速（15分钟）：</div>
            <div>
              {{
                tableData.total_data && tableData.total_data.total_diff
                  ? tableData.total_data.total_diff
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>达标率：</div>
            <div>
              {{
                tableData.total_data &&
                  tableData.total_data.total_compliance_rate
                  ? tableData.total_data.total_compliance_rate
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>有效ROI：</div>
            <div>
              {{
                tableData.total_data && tableData.total_data.total_effective_roi
                  ? tableData.total_data.total_effective_roi
                  : 0
              }}
            </div>
          </div>
        </div>
      </div> -->

      <div class="summary-container">
        <div class="summary-title">合计</div>
        <div class="summary-content">
          <div class="summary-item">
            <div class="item-label">新用户充值（扣除佣金）：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.new_user_recharge || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">消耗：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.total_consume || 0 }}
            </div>
            <div
              v-if="total_data.contrast !== 0"
              :class="['value-indicator', total_data.is_contrast ? 'up' : 'down']"
            >
              <div>{{ total_data.is_contrast ? '↑' : '↓' }}</div>
              <div>
                {{ total_data.is_contrast ? total_data.contrast : total_data.contrast * -1 }}%
              </div>
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">新用户ROI：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.new_user_roi || 0 }}
            </div>
            <div
              v-if="total_data.rio !== 0"
              :class="['value-indicator', total_data.is_rio ? 'up' : 'down']"
            >
              <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>
              <div>
                {{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%
              </div>
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">时速（15分钟）：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.total_diff || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">达标率：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.total_compliance_rate || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">有效ROI：</div>
            <div class="item-value">
              {{ tableData.total_data && tableData.total_data.total_effective_roi || 0 }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <el-table
          ref="tableRef"
          v-loading="loading"
          :data="tableData.list"
          max-height="650"
          style="width: 100%"
          @sort-change="sortChange"
        >
          <el-table-column
            prop="channel_date"
            label="日期"
            width="150"
          />
          <el-table-column
            prop="release_group_name"
            label="投放组"
            width="120"
          />
          <el-table-column
            prop="operation_group_name"
            label="运营组"
            width="120"
          />
          <el-table-column
            prop="pitcher_name"
            label="投手姓名"
          />
          <el-table-column
            prop="platform_name"
            label="书城平台"
            width="120"
          />
          <el-table-column
            prop="position_name"
            label="投放位置"
          />
          <el-table-column
            prop="belong_name"
            label="归属书籍"
            width="120"
          />
          <el-table-column
            prop="belong_type"
            label="书籍类型"
            width="120"
          />
          <el-table-column
            prop="novel_name"
            label="书名"
            width="120"
          />
          <el-table-column
            prop="wechat_names"
            label="公众号名称"
            width="170"
          >
            <template scope="scope">
              <div style="display: flex">
                <ExpandClose :my-values="JSON.parse(scope.row.wechat_names)" />
                <el-button
                  id="copyText"
                  plain
                  style="height: 30px"
                  type="primary"
                  size="mini"
                  @click="copywechatname(scope.row)"
                >复制</el-button>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="roi_standard" label="ROI标准" /> -->
          <el-table-column
            prop="roi_standard"
            label="ROI标准"
            width="110"
          />
          <el-table-column
            prop="effective_roi"
            label="有效ROI"
            width="110"
          >
            <template scope="scope">
              <span style="color: red; font-weight: bold">{{
                scope.row.effective_roi
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="compliance_rate"
            label="ROI达标率"
            width="120"
          >
            <template scope="scope">
              {{ scope.row.compliance_rate }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="consume"
            label="消耗"
            width="110"
            sortable="custom"
          >
            <template scope="scope">
              <div>
                <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{
                  scope.row.consume
                }}</span>
                <input
                  v-else
                  v-model="activeText"
                  type="number"
                  autofocus
                  style="width: 87px; padding: 5px; border: 1px solid #ccc"
                  @blur="blur1"
                >
                <i
                  v-if="!(activeItem && activeItem.id === scope.row.id)"
                  class="el-icon-edit"
                  style="margin-left: 13px; font-size: 19px; cursor: pointer"
                  @click="
                    ;(activeItem = scope.row), (activeText = scope.row.consume)
                  "
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hour_consume_diff"
            label="时速"
            width="110"
            sortable="custom"
          >
            <template scope="scope">
              <div v-if="scope.row.channel_date == nowDate">
                {{ scope.row.hour_consume_diff }}
                <span
                  v-if="scope.row.hour_consume_diff_trend === 'up'"
                  style="color: red"
                >↑</span>
                <span
                  v-else-if="scope.row.hour_consume_diff_trend === 'down'"
                  style="color: green"
                >↓</span>
                <span v-else />
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consume_quality_ratio"
            label="数据质量"
            width="110"
          >
            <template scope="scope">
              <div :style="getQualityStyle(scope.row.consume_quality_ratio)">
                {{ getQualityText(scope.row.consume_quality_ratio) }}
                <span
                  v-if="scope.row.consume_quality_ratio_trend === 'up'"
                  style="color: red"
                >↑</span>
                <span
                  v-else-if="scope.row.consume_quality_ratio_trend === 'down'"
                  style="color: green"
                >↓</span>
                <span v-else />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_recharge_after_sp"
            label="新用户充值（扣除佣金）"
            width="200"
            sortable="custom"
          >
            <template scope="scope">
              <ExpandClose
                :my-values="
                  handleSplicing(scope.row.new_user_recharge_after_sp)
                "
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户roi"
            width="120"
          >
            <template scope="scope">
              <span>{{ scope.row.new_user_roi }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户首充roi"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.tsc_effective_roi">{{
                scope.row.tsc_effective_roi
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sc_commission"
            label="新用户首日首充"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.sc_commission">{{
                scope.row.sc_commission
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户首日首充roi"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.sdsc_effective_roi">{{
                scope.row.sdsc_effective_roi
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payment_growth_rate"
            label="付费增长率"
            width="120"
          >
            <template scope="scope">
              {{ scope.row.payment_growth_rate }}%
            </template>
          </el-table-column>
          <el-table-column
            prop="merits"
            label="有效绩效"
            width="120"
          />
          <el-table-column
            prop="scan_follow_count"
            label="企微客服人数"
            width="150"
            sortable="custom"
          />
          <el-table-column
            prop="scan_follow_cost"
            label="企微客服成本"
            width="150"
            sortable="custom"
          />
          <el-table-column
            prop="from_follow_count"
            label="公众号关注人数"
            width="160"
            sortable="custom"
          />
          <el-table-column
            prop="from_follow_cost"
            label="公众号关注成本"
            width="160"
            sortable="custom"
          />
          <el-table-column
            prop="total_recharge"
            label="每日充值"
            width="120"
          />
          <el-table-column
            prop="total_recharge_commission"
            label="每日充值(扣佣)"
            width="120"
          />
          <el-table-column
            label="操作"
            width="120"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleStopAdvertiser(scope.row)"
              >关停广告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-card v-if="currentDisplayType == 'chart'">
      <!-- <div class="content1">
        <div>合计</div>
        <div class="content-right">
          <div>
            <div>新用户充值（扣除佣金）：</div>
            <div>
              {{
                newtableData.total_data && newtableData.total_data.new_user_recharge
                  ? newtableData.total_data.new_user_recharge
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>消耗：</div>
            <div>
              {{
                newtableData.total_data && newtableData.total_data.total_consume
                  ? newtableData.total_data.total_consume
                  : 0
              }}
            </div>
            <div
              v-if="total_data.contrast !== 0"
              :class="{
                color1: total_data.is_contrast,
                color2: !total_data.is_contrast
              }"
            >
              <div>{{ total_data.is_contrast ? '↑' : '↓' }}</div>
              <div>
                {{
                  total_data.is_contrast
                    ? total_data.contrast
                    : total_data.contrast * -1
                }}%
              </div>
            </div>
          </div>
          <div>
            <div>新用户roi：</div>
            <div>
              {{
                newtableData.total_data && newtableData.total_data.new_user_roi
                  ? newtableData.total_data.new_user_roi
                  : 0
              }}
            </div>
            <div
              v-if="total_data.rio !== 0"
              :class="{ color1: total_data.is_rio, color2: !total_data.is_rio }"
            >
              <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>
              <div>
                {{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%
              </div>
            </div>
          </div>
          <div>
            <div>时速（15分钟）：</div>
            <div>
              {{
                newtableData.total_data && newtableData.total_data.total_diff
                  ? newtableData.total_data.total_diff
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>达标率：</div>
            <div>
              {{
                newtableData.total_data &&
                  newtableData.total_data.total_compliance_rate
                  ? newtableData.total_data.total_compliance_rate
                  : 0
              }}
            </div>
          </div>
          <div>
            <div>有效ROI：</div>
            <div>
              {{
                newtableData.total_data && newtableData.total_data.total_effective_roi
                  ? newtableData.total_data.total_effective_roi
                  : 0
              }}
            </div>
          </div>
        </div>
      </div> -->

      <div class="summary-container">
        <div class="summary-title">合计</div>
        <div class="summary-content">
          <div class="summary-item">
            <div class="item-label">新用户充值（扣除佣金）：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.new_user_recharge || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">消耗：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.total_consume || 0 }}
            </div>
            <div
              v-if="total_data.contrast !== 0"
              :class="['value-indicator', total_data.is_contrast ? 'up' : 'down']"
            >
              <div>{{ total_data.is_contrast ? '↑' : '↓' }}</div>
              <div>{{ total_data.is_contrast ? total_data.contrast : total_data.contrast * -1 }}%</div>
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">新用户ROI：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.new_user_roi || 0 }}
            </div>
            <div
              v-if="total_data.rio !== 0"
              :class="['value-indicator', total_data.is_rio ? 'up' : 'down']"
            >
              <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>
              <div>{{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%</div>
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">时速（15分钟）：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.total_diff || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">达标率：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.total_compliance_rate || 0 }}
            </div>
          </div>

          <div class="summary-item">
            <div class="item-label">有效ROI：</div>
            <div class="item-value">
              {{ newtableData.total_data && newtableData.total_data.total_effective_roi || 0 }}
            </div>
          </div>
        </div>
      </div>

      <div>
        <el-table
          ref="tableRef"
          v-loading="loading"
          :data="newtableData.list"
          max-height="650"
          style="width: 100%"
          @sort-change="sortChange"
        >
          <el-table-column
            prop="channel_date"
            label="日期"
            width="150"
          />
          <el-table-column
            prop="release_group_name"
            label="投放组"
            width="120"
          />
          <el-table-column
            prop="operation_group_name"
            label="运营组"
            width="120"
          />
          <el-table-column
            prop="pitcher_name"
            label="投手姓名"
          />
          <el-table-column
            prop="platform_name"
            label="书城平台"
            width="120"
          />
          <el-table-column
            prop="position_name"
            label="投放位置"
          />
          <el-table-column
            prop="belong_name"
            label="归属书籍"
            width="120"
          />
          <el-table-column
            prop="belong_type"
            label="书籍类型"
            width="120"
          />
          <el-table-column
            prop="novel_name"
            label="书名"
            width="120"
          />
          <el-table-column
            prop="wechat_names"
            label="公众号名称"
            width="170"
          >
            <template scope="scope">
              <div style="display: flex">
                <ExpandClose :my-values="JSON.parse(scope.row.wechat_names)" />
                <el-button
                  id="copyText"
                  plain
                  style="height: 30px"
                  type="primary"
                  size="mini"
                  @click="copywechatname(scope.row)"
                >复制</el-button>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="roi_standard" label="ROI标准" /> -->
          <el-table-column
            prop="roi_standard"
            label="ROI标准"
            width="110"
          />
          <el-table-column
            prop="effective_roi"
            label="有效ROI"
            width="110"
          >
            <template scope="scope">
              <span style="color: red; font-weight: bold">{{
                scope.row.effective_roi
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="compliance_rate"
            label="ROI达标率"
            width="120"
          >
            <template scope="scope">
              {{ scope.row.compliance_rate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="consume"
            label="消耗"
            width="110"
            sortable="custom"
          >
            <template scope="scope">
              <div>
                <span v-if="!(activeItem && activeItem.id === scope.row.id)">{{
                  scope.row.consume
                }}</span>
                <input
                  v-else
                  v-model="activeText"
                  type="number"
                  autofocus
                  style="width: 87px; padding: 5px; border: 1px solid #ccc"
                  @blur="blur1"
                >
                <i
                  v-if="!(activeItem && activeItem.id === scope.row.id)"
                  class="el-icon-edit"
                  style="margin-left: 13px; font-size: 19px; cursor: pointer"
                  @click="
                    ;(activeItem = scope.row), (activeText = scope.row.consume)
                  "
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="hour_consume_diff"
            label="时速"
            width="110"
            sortable="custom"
          >
            <template scope="scope">
              <div v-if="scope.row.channel_date == nowDate">
                {{ scope.row.hour_consume_diff }}
                <span
                  v-if="scope.row.hour_consume_diff_trend === 'up'"
                  style="color: red"
                >↑</span>
                <span
                  v-else-if="scope.row.hour_consume_diff_trend === 'down'"
                  style="color: green"
                >↓</span>
                <span v-else />
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="consume_quality_ratio"
            label="数据质量"
            width="110"
          >
            <template scope="scope">
              <div :style="getQualityStyle(scope.row.consume_quality_ratio)">
                {{ getQualityText(scope.row.consume_quality_ratio) }}
                <span
                  v-if="scope.row.consume_quality_ratio_trend === 'up'"
                  style="color: red"
                >↑</span>
                <span
                  v-else-if="scope.row.consume_quality_ratio_trend === 'down'"
                  style="color: green"
                >↓</span>
                <span v-else />
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_recharge_after_sp"
            label="新用户充值（扣除佣金）"
            width="200"
            sortable="custom"
          >
            <template scope="scope">
              <ExpandClose
                :my-values="
                  handleSplicing(scope.row.new_user_recharge_after_sp)
                "
              />
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户roi"
            width="120"
          >
            <template scope="scope">
              <span>{{ scope.row.new_user_roi }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户首充roi"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.tsc_roi">{{
                scope.row.tsc_roi
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="sc_commission"
            label="新用户首日首充"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.sc_commission">{{
                scope.row.sc_commission
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="new_user_roi"
            label="新用户首日首充roi"
            width="120"
          >
            <template scope="scope">
              <span v-if="scope.row.sdsc_roi">{{
                scope.row.sdsc_roi
              }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="payment_growth_rate"
            label="付费增长率"
            width="120"
          >
            <template scope="scope">
              {{ scope.row.payment_growth_rate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="merits"
            label="有效绩效"
            width="120"
          />
          <el-table-column
            prop="scan_follow_count"
            label="企微客服人数"
            width="150"
            sortable="custom"
          />
          <el-table-column
            prop="scan_follow_cost"
            label="企微客服成本"
            width="150"
            sortable="custom"
          />
          <el-table-column
            prop="from_follow_count"
            label="公众号关注人数"
            width="160"
            sortable="custom"
          />
          <el-table-column
            prop="from_follow_cost"
            label="公众号关注成本"
            width="160"
            sortable="custom"
          />
          <el-table-column
            prop="total_recharge"
            label="每日充值"
            width="120"
          />
          <el-table-column
            prop="total_recharge_commission"
            label="每日充值(扣佣)"
            width="120"
          />
          <el-table-column
            label="操作"
            width="120"
            fixed="right"
          >
            <template scope="scope">
              <el-button
                type="danger"
                size="mini"
                @click="handleStopAdvertiser(scope.row)"
              >关停广告</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
    <el-dialog
      title="导出"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      width="40%"
    >
      <reportdialog
        ref="themeview"
        @updata="updata"
      />
    </el-dialog>

    <el-dialog
      title="导出多维度"
      :visible.sync="dialogVisiblernew"
      :destroy-on-close="true"
      width="40%"
    >
      <reportdialogview
        ref="themeviewnew"
        @updatanew="updatanew"
      />
    </el-dialog>
    <pagination-right
      v-if="currentDisplayType == 'list'"
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <pagination-right
      v-if="currentDisplayType == 'chart'"
      :total="newtableData.count"
      @size-change="fetchPageSizenew"
      @current-change="fetchCurrentPagenew"
    />
  </div>
</template>

<script>
import {
  getReportList,
  getTheListOfOfficialAccount,
  getReleaseGroupList,
  getListOfPitchersInTheLaunchGroup,
  getOperationGroupList,
  getOperatorList,
  getTitleList,
  getBookOwnershipList,
  dropLocationList,
  exportReport,
  modifyConsumption,
  exportAdq,
  updateReleaseBookType,
  releasehanduploadorder,
  userdailyreportbindwechatlist,
  nexportReport,
  exportadvertiserdata,
  stopAdvertisers
} from '@/api/releaseGroup.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import ExpandClose from '@/components/ExpandClose/index.vue'
import reportdialog from './components/reportdialog.vue'
import { getSelectList } from '@/api/report/SelectData.js'
import { commonreportoptions } from '@/api/copyReleaseGroup.js'
import reportdialogview from './components/reportdialognew.vue'
// import { ElStep } from 'element-ui/types/step'
export default {
  components: {
    PaginationRight,
    ExpandClose,
    reportdialog,
    reportdialogview
    /* Details */
  },
  data() {
    return {
      tableData: {},
      total_data: {
        rio: null,
        contrast: null,
        is_rio: false,
        is_contrast: false
      },
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        belong_type: null,
        book_id: null,
        position_id: null,
        platform_id: null
      },
      parameterNames: {
        app_id_name: null, // 公众号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null, // 书籍类型
        position_id_name: null, // 投放位置
        platform_name: null,
        launch_platform_type: ''
      },
      order_by: {}, // 表格数据排序
      current: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      nowDate: this.getNowFormatDate(window.Date.now()),
      activeText: null,
      drawerItem: {},
      dialogVisibler: false,
      optionbook: [],
      currentDisplayType: 'chart', // 用于控制列表/图表显示模式
      newtableData: {},
      options: [],
      dialogVisiblernew: false
    }
  },
  computed: {
    getQualityStyle() {
      return function(ratio) {
        if (parseFloat(ratio) === 0) {
          return ''
        }
        if (parseFloat(ratio) > 80) {
          return 'color: red'
        } else if (parseFloat(ratio) > 50) {
          return 'color: orange'
        } else {
          return 'color: green'
        }
      }
    },
    getQualityText() {
      return function(ratio) {
        if (parseFloat(ratio) === 0) {
          return '-'
        }
        // if (parseFloat(ratio) > 80) {
        //   return '优秀'
        // } else if (parseFloat(ratio) > 50) {
        //   return '良好'
        // } else {
        //   return '较差'
        // }
        if (parseFloat(ratio) >= 100) {
          return '优秀'
        } else if (parseFloat(ratio) >= 80) {
          return '较好'
        } else if (parseFloat(ratio) >= 50) {
          return '正常'
        } else if (parseFloat(ratio) >= 30) {
          return '较差'
        } else {
          return '低质'
        }
      }
    }
  },
  created() {
    window.aa = this
    // this.getDataList()
    this.getDataListnew()
    this.oplistr()
    if (this.optionbook.length >= 0) {
      this.booktypeList()
    }
  },
  methods: {
    async booktypeList() {
      const res = await updateReleaseBookType()
      this.optionbook = res.data
    },
    copywechatname(data) {
      console.log('data:', data.ocean_advertiser, data.advertiser)
      if (data.ocean_advertiser.length === 0 && data.advertiser.length === 0) {
        return this.$message('没有可复制的数据')
      }
      // const newdata = data.advertiser.length === 0 ? data.ocean_advertiser : data.advertiser
      const newdata =
  data.advertiser && data.advertiser.length > 0
    ? data.advertiser
    : data.ocean_advertiser && data.ocean_advertiser.length > 0
      ? data.ocean_advertiser
      : data.baidu_advertiser
      if (newdata.length >= 1) {
        const arr = []
        newdata.map(item => {
          if (item.agent_name) {
            // const formatStr = `${item.account_name}-${item.account_id}-${item.agent_name}`
            const formatStr = `${item.account_id}`
            arr.push(formatStr)
          } else {
            const idStr = `${item.account_id}`
            arr.push(idStr)
          }
        })
        const str = arr.join(',').trim()
        if (!navigator.clipboard) {
          const dummyInput = document.createElement('textarea')
          dummyInput.value = str
          dummyInput.style.left = '-9999px'
          dummyInput.style.top = '-9999px'
          dummyInput.style.textAlign = 'left'
          dummyInput.style.whiteSpace = 'pre-line'
          document.body.appendChild(dummyInput)
          dummyInput.select()
          document.execCommand('copy')
          document.body.removeChild(dummyInput)
        } else {
          navigator.clipboard.writeText(str)
        }
      }
    },
    // 获取数据列表
    async getDataList(obj = {}) {
      // console.log('parameter参数=======', this.parameter)
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'consume'
        }
      }
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getReportList({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.tableData = data.data
      // if (data.data.list.length !== 0) {
      //   // this.tableData.list = this.tableData.list.map((v) => {
      //   //   v.effective_roi = '13%'
      //   //   return v
      //   // })
      //   this.tableData.list.sort((a, b) => b.consume - a.consume)
      // }
      this.total_data.contrast = Number(data.data.total_data.consume_contrast.split('%')[0])
      this.total_data.rio = Number(data.data.total_data.roi_contrast.split('%')[0])
      if (this.total_data.contrast > 0) {
        this.total_data.is_contrast = true
      } else {
        this.total_data.is_contrast = false
      }
      if (this.total_data.rio > 0) {
        this.total_data.is_rio = true
      } else {
        this.total_data.is_rio = false
      }
      this.loading = false
    },

    // 获取数据列表
    async getDataListnew(obj = {}) {
      // console.log('parameter参数=======', this.parameter)
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'consume'
        }
      }
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await userdailyreportbindwechatlist({
        ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.newtableData = data.data
      // if (data.data.list.length !== 0) {
      //   // this.tableData.list = this.tableData.list.map((v) => {
      //   //   v.effective_roi = '13%'
      //   //   return v
      //   // })
      //   this.tableData.list.sort((a, b) => b.consume - a.consume)
      // }
      this.total_data.contrast = Number(data.data.total_data.consume_contrast.split('%')[0])
      this.total_data.rio = Number(data.data.total_data.roi_contrast.split('%')[0])
      if (this.total_data.contrast > 0) {
        this.total_data.is_contrast = true
      } else {
        this.total_data.is_contrast = false
      }
      if (this.total_data.rio > 0) {
        this.total_data.is_rio = true
      } else {
        this.total_data.is_rio = false
      }
      this.loading = false
    },
    reportExxiter() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.themeview.send()
      })
    },
    updata() {
      this.dialogVisibler = false
      this.$message({
        message: '操作成功，请在导出列表下载',
        type: 'success'
      })
    },
    reportExxiternew() {
      this.dialogVisiblernew = true
      this.$nextTick(() => {
        this.$refs.themeviewnew.send()
      })
    },
    updatanew() {
      this.dialogVisiblernew = false
      this.$message({
        message: '操作成功，请在导出列表下载',
        type: 'success'
      })
    },
    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },
    // 分页
    fetchPageSizenew(s) {
      this.parameter.pageSize = s
      this.search(true)
    },

    // 分页
    fetchCurrentPagenew(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        公众号: 'account_name',
        投放组: 'release_group_name',
        投手: 'user_name',
        运营组: 'operation_group_name',
        运营者: 'user_name',
        书籍归属: 'book_name',
        书籍类型: 'type_name',
        书名: 'novel_name',
        投放位置: 'position_name',
        平台: 'platform_name'
      }

      switch (this.current) {
        case '公众号':
          currentFunc = getTheListOfOfficialAccount
          break
        case '投放组':
          currentFunc = getReleaseGroupList
          break
        case '投手':
          currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组':
          currentFunc = getOperationGroupList
          break
        case '运营者':
          currentFunc = getOperatorList
          break
        case '书名':
          currentFunc = getTitleList
          break
        case '书籍归属':
          currentFunc = getBookOwnershipList
          break
        case '书籍类型':
          currentFunc = updateReleaseBookType
          break
        case '投放位置':
          currentFunc = dropLocationList
          break
        case '平台':
          currentFunc = getSelectList
          break
      }
      if (!currentFunc) {
        return
      }

      if ((this.current === '投手' && !this.parameter.release_group_id) || (this.current === '运营者' && !this.parameter.operation_group_id) || (this.current === '书名' && !this.parameter.book_id)) {
        const obj1 = {
          投手: '请先选投放组，才能选投手',
          运营者: '请先选运营组，才能选运营者',
          书名: '请先选择书籍归属，才能选书名'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      console.log(data)
      if (this.current === '书籍类型') {
        cb(
          data.data.map(item => {
            return {
              value: item,
              address: item
            }
          })
        )
        return
      } else if (this.current === '平台') {
        cb(
          data.data.platform.map(item => {
            return {
              value: item.name,
              address: item.id
            }
          })
        )
        return
      }
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(
        data.data.list.map(item => {
          return {
            value: item[obj[this.current]],
            address: this.current === '公众号' ? item.app_id : item.id
          }
        })
      )
    },

    // 选中哪一项
    handleSelect(item) {
      console.log(item, '----')
      switch (this.current) {
        case '公众号':
          this.parameter.app_id = item
          break
        case '投放组':
          this.parameter.release_group_id = item
          break
        case '投手':
          this.parameter.pitcher_id = item
          break
        case '运营组':
          this.parameter.operation_group_id = item
          break
        case '运营者':
          this.parameter.operation_id = item
          break
        case '书名':
          this.parameter.alias_book_id = item
          break
        case '书籍归属':
          this.parameter.book_id = item
          break
        case '投放位置':
          this.parameter.position_id = item
          break
        case '书籍类型':
          this.parameter.belong_type = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      // 清空排序
      !value && (this.order_by.field || this.order_by.order) ? this.sortOrderChang() : null
      const obj = {
        app_id: 'app_id_name',
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        alias_book_id: 'alias_book_id_name',
        book_id: 'book_id_name',
        belong_type: 'belong_type_name',
        position_id: 'position_id_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      const obj1 = {}
      keys.map(key => {
        if (this.parameter[key] && this.parameter[key].value === this.parameterNames[obj[key]] && key !== 'page' && key !== 'pageSize') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'pageSize') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })
      if (this.parameterNames.belong_type_name) {
        obj1.belong_type = this.parameterNames.belong_type_name
      }

      obj1.launch_platform_type = this.parameterNames.launch_platform_type
      // value === '导出' || this.getDataList(obj1)
      // return obj1
      if (value === '导出') {
        return obj1
      } else {
        // eslint-disable-next-line eqeqeq
        if (this.currentDisplayType == 'list') {
          this.getDataList(obj1)
        } else {
          this.getDataListnew(obj1)
        }
      }
    },
    // 清空排序
    sortOrderChang() {
      this.order_by = {}
      this.$refs.tableRef.clearSort()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        app_id: null,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        alias_book_id: null,
        book_id: null,
        belong_type: null,
        position_id: null
      }
      this.parameterNames = {
        app_id_name: null, // 公众号
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        alias_book_id_name: null, // 书名
        book_id_name: null, // 书籍归属
        belong_type_name: null, // 书籍类型
        position_id_name: null, // 投放位置
        launch_platform_type: ''
      }
      this.date = []
      this.current = null
      this.sortOrderChang()
      // eslint-disable-next-line eqeqeq
      if (this.currentDisplayType == 'list') {
        this.getDataList()
      } else {
        this.getDataListnew()
      }
      // this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportReport({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    // 导出报表
    async reportExporting() {
      const obj = this.search('导出')
      await nexportReport({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    // 广告主消耗导出报表
    async reportAdq() {
      const obj = this.search('导出')
      await exportAdq({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    // 广告主消耗导出报表新
    async reportAdqnew() {
      const obj = this.search('导出')
      await exportadvertiserdata({
        ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      // this.reset('no')
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await modifyConsumption({
            id: this.activeItem.id,
            consume: this.activeText
          })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },

    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },

    handleSplicing(new_user_recharge_after_sp) {
      const arr = []
      for (const key in new_user_recharge_after_sp) {
        arr.push(`${key}: ${new_user_recharge_after_sp[key]}`)
      }
      // console.log('----------', new_user_recharge_after_sp)
      return arr
    },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : this.handleSort(cell.column.label)
      this.search('排序')
    },
    handleSort(label) {
      let field = ''
      switch (label) {
        case '消耗':
          field = 'consume'
          break
        case '新用户充值（扣除佣金）':
          field = 'new_user_recharge'
          break
        case '企微客服人数':
          field = 'scan_follow_count'
          break
        case '企微客服成本':
          field = 'scan_follow_cost'
          break
        case '公众号关注人数':
          field = 'from_follow_count'
          break
        case '公众号关注成本':
          field = 'from_follow_cost'
          break
      }
      return field
    },
    switchToChart() {
      this.currentDisplayType = 'chart'
      this.parameter.page = 1
      this.search(true)
    },
    switchToList() {
      this.currentDisplayType = 'list'
      this.parameter.page = 1
      this.search(true)
    },
    async uploadPicturesr(e) {
      console.log('e.target.files', e.target.files)
      // eslint-disable-next-line eqeqeq
      const extension = e.target.files[0].name.split('.').slice(-1) == 'xlsx'
      if (!extension) {
        this.$message.warning('上传模板只能是xlsx格式!')
        return
      }
      const form = new FormData()
      form.append('file', e.target.files[0])
      const data = await releasehanduploadorder(form)
      this.$message({
        message: '上传成功',
        type: 'success'
      })
      console.log('data', data)
    },
    async oplistr() {
      const res = await commonreportoptions()
      this.options = res.data.launch_platform_type
    },
    // 关停广告
    async handleStopAdvertiser(row) {
      if (!row.bind_id) {
        this.$message({
          message: '缺少 bind_id 参数',
          type: 'warning'
        })
        return
      }

      try {
        await this.$confirm('确定要关停该广告吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await stopAdvertisers({
          bind_id: row.bind_id
        })

        this.$message({
          message: res.data.message || '操作成功',
          type: 'success'
        })

        // 刷新列表
        if (this.currentDisplayType === 'list') {
          this.getDataList()
        } else {
          this.getDataListnew()
        }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message({
            message: error.message || '关停广告失败',
            type: 'error'
          })
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
textarea {
  text-align: left;
  white-space: pre-line;
}
.content {
  .item {
    display: flex;
    align-items: center;

    .item_title {
      display: inline-block;
      width: 100px;
    }

    .item_input {
      width: 200px;
    }
  }
}

.selectionArea {
  display: flex;
  flex-wrap: wrap;

  .item {
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;

    .item_title {
      margin-right: 10px;
      display: inline-block;
    }

    .item_input {
      width: 200px;
    }
  }
}

.powder {
  background: rgb(248, 216, 216);
}

.green {
  background: rgb(52, 229, 54);
}

.yellow {
  background: rgb(255, 247, 173);
}

.red {
  background: #ffa500;
}

.magRig {
  margin-right: 10px;
}

.magLfte {
  margin-left: 10px;
}

.chong {
  display: inline-block;
  width: 13px;
  height: 86%;
  margin-left: 6px;
}

.mybox {
  margin-left: 20px;
  display: flex;
  align-items: center;
}
.publicItems{
 padding: 20px;
}
.publicItems .el-dialog {
  margin-top: 6vh !important;
}

.color2 {
  color: #0ebb0e;
}

.color1 {
  color: #ef0505;
}
.content1 {
  color: #1d2129;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;

  .content-right {
    display: flex;
    div {
      display: flex;
      align-items: center;

      div:first-of-type {
        margin-left: 30px;
      }
    }
  }
}
.style-tab {
  width: 124px;
  height: 36px;
  background-color: #f2f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  div {
    width: 42px;
    height: 24px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    img {
      width: 16px;
      height: 16px;
    }
  }
  span {
    margin: 0px 5px;
    color: #ccc;
  }
}
/* 当处于激活状态时，设置背景为白色 */
.active-bg {
  background-color: #ffffff;
}

.summary-container {
  display: flex;
  align-items: flex-start;
  padding: 12px;
  gap: 20px;
  font-family: sans-serif;
  max-width: 100%;
  margin-left: auto; /* ✅ 让整个区域靠右 */
  justify-content: flex-start;
}

.summary-title {
  font-weight: bold;
  width: 60px;
  flex-shrink: 0;
    font-size: 18px;
}

.summary-content {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  flex: 1;
}

.summary-item {
  display: flex;
  min-width: 160px;
  font-size: 18px;
}

.item-label {
  color: #888;
  margin-bottom: 4px;
}

.item-value {
  font-weight: 500;
}

.value-indicator {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 4px;
  font-size: 18px;
  font-weight: bold;
}

.value-indicator.up {
  color: #f5222d;
}

.value-indicator.down {
  color: #52c41a;
}

</style>
